import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@mdi/font/css/materialdesignicons.css";
const light = {
  link: "#009688",
  primary: "#009688",
  secondary: "#ff9800",
  accent: "#00bcd4",
  error: "#f44336",
  warning: "#ffeb3b",
  info: "#2196f3",
  success: "#8bc34a"
};
const dark = {
  primary: "#000000",
  link: "#009688",
};
Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    // dark :true
    themes: {
      light,
      dark
    }

  }
});